"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GROUP_CALL_MODERATOR_JOIN_GRACE_PERIOD = exports.GROUP_CALL_MEMBER_JOIN_GRACE_PERIOD = void 0;
// In minutes, to buffer meeting start and end accordingly
var GROUP_CALL_MODERATOR_JOIN_GRACE_PERIOD = 10;
exports.GROUP_CALL_MODERATOR_JOIN_GRACE_PERIOD = GROUP_CALL_MODERATOR_JOIN_GRACE_PERIOD;
var GROUP_CALL_MEMBER_JOIN_GRACE_PERIOD = 5;
exports.GROUP_CALL_MEMBER_JOIN_GRACE_PERIOD = GROUP_CALL_MEMBER_JOIN_GRACE_PERIOD;